import clsx from 'clsx'
import { FieldSet, Radio } from 'shared/ui'

import css from './Filters.module.css'

const AVATAR_OPTIONS = [
	{ label: 'Any', value: '0' },
	{ label: 'Yes', value: '1' },
	{ label: 'No', value: '2' }
]

export const Avatar = ({
	className,
	initial = '0',
	name = 'avatar'
}: {
	className?: string
	initial?: string
	name?: string
}) => (
	<FieldSet
		className={clsx(css.set, css.status, className)}
		key={initial}
		legend='Avatar'
		legendCN={clsx(css.label, css.label)}
		level='h5'
	>
		{AVATAR_OPTIONS.map(({ label, value }) => (
			<label className={css.radio} key={label}>
				<Radio
					defaultChecked={initial === value}
					name={name}
					value={value}
				/>
				{label}
			</label>
		))}
	</FieldSet>
)
